export const PROT_OBJECT = Object.freeze({
  PwT: 'Т',
  AT: 'АТ',
  PwL: 'ЛЭП',
  R: 'ШР',
  BUS: 'СШ',
  BUSBAR: 'Ошиновка',
  //MANUAL: 'Вручную',
});

export const POWER_LINE = Object.freeze({
  AIR: 'ВЛ',
  CABLE: 'КЛ',
  CABLE_AIR: 'КВЛ',
});

// export const POWER_T = Object.freeze({
//   T2: 'T2', // 'двухобмоточный
//   T2sp: 'T2sp', // 'с расщеплённой обмоткой
//   T3: 'T3', // 'трёхобмоточный
// });

export const PROT_OBJECT_INFO = Object.freeze({
  [PROT_OBJECT.PwT]: {
    name: 'Трансформатор',
    maxOnly: false, // данные вводить для максимального и минимального режимов
    // subKinds: [
    // //   { id: 'Т2', name: 'двухобмоточный' },
    // //   { id: 'Т3', name: 'трёхобмоточный' },
    // //   { id: 'Т2spl', name: 'с расщеплённой обмоткой' },
    // // ],
  },
  [PROT_OBJECT.AT]: {
    name: 'Автотрансформатор',
    maxOnly: false, // данные вводить для максимального и минимального режимов
  },
  [PROT_OBJECT.PwL]: {
    name: 'ЛЭП',
    maxOnly: true, // данные вводить только для максимального режима
    subKinds: {
      [POWER_LINE.AIR]: 'воздушная',
      [POWER_LINE.CABLE]: 'кабельная',
      [POWER_LINE.CABLE_AIR]: 'кабельно-воздушная',
    },
  },
  [PROT_OBJECT.R]: {
    name: 'Шунтирующий реактор',
    // maxOnly: ХЗ
    // subKinds: [
    //   { id: 'ШР1', name: 'одинарный' },
    //   { id: 'ШР2', name: 'сдвоенный' },
    // ],
  },
  [PROT_OBJECT.BUS]: {
    id: 'СШ',
    name: 'Сборные шины',
    // maxOnly: ХЗ
  },
});

export const PROTECTION = Object.freeze({
  DTZ: 'ДТЗ',
  DZ: 'ДЗ',
  DZL: 'ДЗЛ',
  KSZ: 'КСЗ',
  DFZ: 'ДФЗ',
  NVChZ: 'НВЧЗ',
  DZO: 'ДЗО', // дифференциальная защита ошиновки АТ
  // TEST: 'ТЕСТ',
});

export const PROTECTION_INFO = Object.freeze({
  DTZ: {
    kind: PROTECTION.DTZ,
    name: 'ДТЗ',
    comment: 'дифференциальная токовая защита', //трансформаторов
    objects: [PROT_OBJECT.PwT],
  },
  DZ: {
    kind: PROTECTION.DZ,
    name: 'ДЗ',
    comment: 'дистанционная защита линии', //ЛЭП
    objects: [PROT_OBJECT.PwL],
  },
  DZL: {
    kind: PROTECTION.DZL,
    name: 'ДЗЛ',
    comment: 'дифференциальная защита линии', //ЛЭП
    objects: [PROT_OBJECT.PwL],
  },
  KSZ: {
    kind: PROTECTION.KSZ,
    name: 'КСЗ',
    comment: 'комплект ступенчатых защит', //ЛЭП
    objects: [PROT_OBJECT.PwL],
  },
  DFZ: {
    kind: PROTECTION.DFZ,
    name: 'ДФЗ',
    comment: 'дифференциально-фазная защита', //ЛЭП
    objects: [PROT_OBJECT.PwL],
  },
  NVChZ: {
    kind: PROTECTION.NVChZ,
    name: 'НВЧЗ',
    comment: 'направленная высокочастотная защита', //ЛЭП
    objects: [PROT_OBJECT.PwL],
  },
  DZO: {
    kind: PROTECTION.DZO,
    name: 'ДЗО',
    comment: 'дифференциальная защита ошиновки',
    objects: [PROT_OBJECT.BUSBAR],
  },
  // TEST: {
  //   kind: PROTECTION.TEST,
  //   name: 'Тестовая защита',
  //   comment: 'тестовый вид защиты',
  //   objects: [PROT_OBJECT.PwL],
  // },
});

//Схема распредустройства
export const VOLTAGE_LEVEL_KIND = Object.freeze({
  B_1: '1В', // Один выключатель на присоединение
  B_3_2: '3/2', // Полуторная
  B_4_3: '4/3', // Четыре третьих
  B_2: '2В', // Два выключателя на присоединение
  MANY: 'Мн', //Многоугольник
  TB_3_2: 'ТШ 3/2', // Трансформаторы-шины с полуторным присоединением линий
  TB_2: 'ТШ 2В', // Трансформаторы-шины с присоединением линий через два выключателя
});

// Информация по распредустройствам
export const VOLTAGE_LEVEL_INFO = Object.freeze({
  [VOLTAGE_LEVEL_KIND.B_1]: {
    name: 'Один выключатель',
    // neighbor_bays: 0, //число смежных присоединений (для защиты линии)
  },
  [VOLTAGE_LEVEL_KIND.B_3_2]: {
    name: 'Полуторная',
    // neighbor_bays: 1,
  },
  [VOLTAGE_LEVEL_KIND.B_4_3]: {
    name: 'Четрые третьих',
    // neighbor_bays: 1,
  },
  [VOLTAGE_LEVEL_KIND.B_2]: {
    name: 'Два выключателя',
    // neighbor_bays: 0,
  },
  [VOLTAGE_LEVEL_KIND.MANY]: {
    name: 'Многоугольник',
    // neighbor_bays: 2,
  }, //
});

//место ТТ
export const CT_PLACE = Object.freeze({
  LINE: 'ЛЭП',
  BREAKER: 'В',
});

export const CT_PLACE_T = Object.freeze({
  LINEAR: 'ЛИНЕЙНЫЕ',
  PHASE: 'ФАЗНЫЕ',
  I: 'I',
});

//Модель ТТ
export const CT_MODEL = Object.freeze({
  GOST: 'ГОСТ',
  QUASAR: 'Квазар',
  VAH: 'ВАХ',
});

export const CT_SCHEMA = Object.freeze({
  Y_IND: 'I', //Подключение индивидуальными проводниками
  Y_COMM: 'Yо', //Звезда с общим нулевым проводником
  //   Y_INCOMP : 'Yнеполн', //Неполная звезда
  // D        : 'D' // Треугольник
});

//Напряжения
export const VOLTAGES = [6, 10, 15, 20, 24, 27, 35, 110, 150, 220, 330, 400, 500, 750];

export const CT_I_SEC = [1, 5]; // Вторичные токи ТТ, А

export const CT_CLASS = Object.freeze({
  P: 'P', // # без зазора
  //# остальные - с зазором
  PR: 'PR',
  TPY: 'TPY',
  TPZ: 'TPZ',
});

// export const CT_ACCURACY = ['5P', '10P', '5PR', '10PR', 'TPY', 'TPZ'];
export const CT_ACCURACY = Object.freeze({
  [CT_CLASS.P]: ['5P', '10P'],
  [CT_CLASS.PR]: ['5PR', '10PR'],
  [CT_CLASS.TPY]: ['TPY'],
  [CT_CLASS.TPZ]: ['TPZ'],
});

export const ACCURACY_TO_CT_CLASS = Object.freeze(
  Object.entries(CT_ACCURACY).reduce((acc, [ctClass, accuracyList]) => {
    accuracyList.forEach((accuracy) => {
      acc[accuracy] = ctClass;
    });
    return acc;
  }, {}),
);

// Вторичный ток
export const RATED_SECONDARY_CURRENT = [1, 5];

export const ACCURACY = [5, 10];
export const CT_CLASS_VALUES = Object.values(CT_CLASS);

export const ACCURACY_CLASS = CT_CLASS_VALUES.flatMap((ctClass) =>
  ACCURACY.map((accuracy) => `${accuracy}${ctClass}`),
);

export const CALC_MODE = Object.freeze({
  EXTERNAL: 'внешний', // используются результаты расчёт ТКЗ во внешних комплексах (вводятся вручную)
  INTERNAL: 'авто', // расчёт ТКЗ в программном комплексе
});

export const ВИД_КЗ = Object.freeze({
  К1: '1',
  К2: '2', // двухфазное
  К3: '3',
  К1_1: '1.1', // двухфазное на землю
});

export const DOC_KIND = Object.freeze({
  CHECK: 'проверка', // проверка ТТ
  ASSIGNMENT: 'задание', // задание заводу-изготовителю
  SELECT: 'выбор', // выбор
  TNAS: 'tнас',
});

/** Значения Kr по умолчанию */
export const getDefaultKr = (class_ct) => {
  switch (class_ct) {
    case CT_CLASS.P:
      return 0.86;
    case CT_CLASS.PR:
      return 0.1;
    case CT_CLASS.TPY:
      return 0.1;
    case CT_CLASS.TPZ:
      return 0.1;
    default:
      return null;
  }
};

export const WITH_APV = [CT_CLASS.PR, CT_CLASS.TPY];
export const WITH_BSTO_PROT = [
  PROTECTION.DZL,
  PROTECTION.DZ,
  PROTECTION.DFZ,
  PROTECTION.NVChZ,
  PROTECTION.KSZ,
];

/** Может ли быть смежное присоединение (см. схемы) */
export const may_have_neighbor = (vl_kind, prot_kind, ctParams) =>
  ctParams['isEmbedded'] === true &&
  ctParams['ctPlace'] === CT_PLACE.BREAKER &&
  [VOLTAGE_LEVEL_KIND.B_3_2, VOLTAGE_LEVEL_KIND.B_4_3, VOLTAGE_LEVEL_KIND.MANY].includes(vl_kind);

export const may_have_bsto = (protKind, objectKind, ctPlace, schemeRu) =>
  WITH_BSTO_PROT.includes(protKind) &&
  objectKind === PROT_OBJECT.PwL &&
  ctPlace === CT_PLACE.BREAKER &&
  schemeRu !== VOLTAGE_LEVEL_KIND.B_1;

// export const may_have_bsto = (protKind, objectKind, ctPlace, schemeRu) => {
//   if (WITH_BSTO_PROT.includes(protKind) &&
//       objectKind === PROT_OBJECT.PwL &&
//       ctPlace === CT_PLACE.BREAKER &&
//       schemeRu !== VOLTAGE_LEVEL_KIND.B_1
//   ) {
//     return true;
//   } else {
//     return false;
//   }
// }

export const TRANSFORMER_TYPES = Object.freeze({
  T2: 'Т2',
  T2_SPLIT: 'ТРО',
  T3: 'Т3',
  AT: 'АТ',
});

/** Подвиды объекта «ошиновка». */
export const BUSBAR_TYPES = Object.freeze({
  AT: 'ОАТ',
});

/**
 * Объекты с параметрами силового трансформатора (Т и ошиновка АТ).
 * Ошиновка АТ использует те же паспорт, нейтрали, ТТ и схемы, что и АТ.
 */
export const isTransformerKind = (objectKind) => 
  objectKind === PROT_OBJECT.PwT || objectKind === PROT_OBJECT.BUSBAR;

/** Приводит subKind ошиновки АТ к типу трансформатора (АТ); остальные не меняет. */
export const toTransformerType = (subKind) => 
  subKind === BUSBAR_TYPES.AT ? TRANSFORMER_TYPES.AT : subKind;

export const REGULATING_TRANSFORMER_TYPES = Object.freeze({
  SERIES: 'ВРТ',
  LINEAR: 'ЛРТ',
});

export const REACTOR_TYPES = Object.freeze({
  RTU: 'УШР',
  SHUNT: 'ШР',
  GROUND: 'ЗР',
  ARC: 'ДГР',
  SINGLE: 'ОР',
  DUAL: 'СТОР',
  LIMITING_HV: 'ТОР',
});

export const STANDARD_U_NOM_NN_VALUES = [
  3.15, 6.3, 6.6, 10.5, 11, 13.8, 15.75, 20, 27.5, 34.5, 36.5,
];

export const REGULATION_TYPE = Object.freeze({
  RPN: 'РПН',
  PBV: 'ПБВ',
});

export const REGULATION_LOCATION = Object.freeze({
  NEUTRAL: 'нейтраль',
  PHASE: 'фазное',
});

export const VOLTAGE_SIDE_T2 = Object.freeze({
  HV: 'ВН',
  LV: 'НН',
});

export const VOLTAGE_SIDE_T2_SPLIT = Object.freeze({
  HV: 'ВН',
  LV1: 'НН1',
  LV2: 'НН2',
});

export const VOLTAGE_SIDE_T3 = Object.freeze({
  HV: 'ВН',
  MV: 'СН',
  LV: 'НН',
});

export const VOLTAGE_SIDE_AT = Object.freeze({
  HV: 'ВН',
  MV: 'СН',
  LV: 'НН',
});

// export const SCHEME_T = Object.freeze({
//   Yn: 'Ун',
//   Y: 'У',
//   D: 'Д',
// })

export const SCHEME_T2 = Object.freeze({
  Yn_D: 'Ун/Д',
  Y_D: 'У/Д',
});

export const SCHEME_T2_SPLIT = Object.freeze({
  Yn_D_D: 'Ун/Д/Д',
  Y_D_D: 'У/Д/Д',
  Yn_Y_D: 'Ун/У/Д',
  Y_Y_D: 'У/У/Д',
  Yn_D_Y: 'Ун/Д/У',
  Y_D_Y: 'У/Д/У',
});

export const SCHEME_T3 = Object.freeze({
  Yn_D_D: 'Ун/Д/Д',
  Y_D_D: 'У/Д/Д',
});

export const SCHEME_AT = Object.freeze({
  Yn_Yn_D: 'Ун/Ун/Д',
});

export const T_U_NOM_PRIMARY = [
  0.38, 6, 6.3, 10, 10.5, 35, 36.75, 110, 115, 230, 330, 500, 750, 1150,
];

export const T_U_NOM_SECONDARY = [0.4, 6.3, 6.6, 10.5, 11, 38.5, 121, 230, 242, 330, 347, 545, 787];

export const SETTING_UNITS = Object.freeze({
  A: 'А',
  kA: 'кА',
  V: 'В',
  kV: 'кВ',
  s: 'с',
  ms: 'мс',
  ohm: 'Ом',
  deg: '°',
  percent: '%',
  pu: 'о.е.',
  Hz: 'Гц',
  W: 'Вт',
  VA: 'ВА',
  kW: 'кВт',
  kVA: 'кВА',
  without: '-',
});

export const SETTING_UNITS_KIND = Object.freeze({
  PRIMARY: 'Первичные',
  SECONDARY: 'Вторичные',
  NOTHING: '—',
});

export const VAL_KIND = Object.freeze({
  BOOLEAN: 'Boolean',
  FLOAT: 'Float',
  INT: 'Int',
  STRING: 'String',
  COMPLEX: 'Complex',
});

export const BOX_SPECIFIC = Object.freeze({
  ROSATOM: 'Росатом',
  ROSSETI: 'Россети',
});

export const FUNCTION_NAMES = Object.freeze({
  FUNC1: 'Func1',
  FUNC2: 'Func2',
  FUNC3: 'Func3',
  FUNC4: 'Func4',
  FUNC5: 'Func5',
});

export const EMBEDDED_EQUIMPENT_TYPE = Object.freeze({
  BREAKER: 'В', // выключатель
  TRANSFORMER: 'Т', // силовой трансформатор
});

/**
 * Сопоставление индекса стороны трансформатора с её названием.
 */
// export const TRANSFORMER_SIDE_NAMES = { 0: 'ВН', 1: 'СН', 2: 'НН' };
export const TRANSFORMER_COMMON_SIDE_NAMES = ['ВН', 'СН', 'НН'];
export const TRANSFORMER_SPLIT_SIDE_NAMES = ['ВН', 'НН1', 'НН2'];

export const TRANSFORMER_SIDE_NAMES = (transformerType) =>
  transformerType === TRANSFORMER_TYPES.T2_SPLIT
    ? TRANSFORMER_SPLIT_SIDE_NAMES
    : TRANSFORMER_COMMON_SIDE_NAMES;

export const NEUTRAL = Object.freeze({
  INSULATED: 'insulated',
  SOLIDLY: 'solidly',
  // IMPEDANCE: 'impedance',
});

/** Отображаемые подписи режимов нейтрали. */
export const NEUTRAL_LABELS = Object.freeze({
  [NEUTRAL.INSULATED]: 'Изолированная',
  [NEUTRAL.SOLIDLY]: 'Глухозаземлённая',
  // [NEUTRAL.IMPEDANCE]: 'Резистивное заземление',
});

export const FIRST_SYSTEM_KEY = 'S1'